import { ReactPortal, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { IModalProps } from '../../interfaces';

const modalRootElement: Element | null = document.querySelector("#modal");


export default function Modal(props: IModalProps): ReactPortal | null {
    const {
        children,
        open,
        onClose,
        hideCloseButton,
        style,
    } = props;

    const element: HTMLDivElement = useMemo(() => document.createElement('div'), []);

    useEffect(() => {
        if (open) {
            modalRootElement?.appendChild(element);

            return (): void => {
                modalRootElement?.removeChild(element);
            }
        }
    });

    if (open) {
        return createPortal(
            <div className="modal_background" onClick={onClose}>
                <div
                    className="modal_background_container"
                    style={style}
                    onClick={(e) => e.stopPropagation()}
                >
                    {children}
                    {
                        hideCloseButton ? null : <i className="gg-close" onClick={onClose}/>
                    }
                </div>
            </div>,
            element,
        );
    }

    return null;
}